// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"49f14471","485":"ad37ba8c","942":"8b3211ea"}[chunkId] + ".chunk.js";
};